import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { formatNumberWithCommas } from "./utils/creditUtils";
import { useCredits } from '@/hooks/useCredits';

export const HeaderCreditsDisplay: React.FC = () => {
  const navigate = useNavigate();
  const { balance: credits, isLoading } = useCredits();

  const handleClick = () => {
    navigate('/settings', { state: { tab: 'credits' } });
  };

  if (isLoading) {
    return (
      <Button variant="ghost" size="sm" className="h-8 px-2 animate-pulse bg-stewie-blue/20">
        <div className="h-4 w-16 bg-stewie-gray/30 rounded"></div>
      </Button>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClick}
            className="h-8 bg-stewie-blue/20 text-stewie-blue hover:bg-stewie-blue/30 hover:text-white"
          >
            <svg 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4 mr-1.5"
            >
              <path 
                d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            <span>{formatNumberWithCommas(credits || 0)} Credits</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent className="p-3 max-w-xs bg-stewie-charcoal border-stewie-gray/30">
          <div className="space-y-2">
            <p className="font-medium text-white">Stewie Credits Balance</p>
            <div className="text-sm text-stewie-gray">
              <div className="flex justify-between">
                <span>Available Credits:</span>
                <span className="text-white font-medium">{formatNumberWithCommas(credits || 0)}</span>
              </div>
              <div className="flex justify-between mt-1">
                <span>Tradeable AUM:</span>
                <span className="text-white font-medium">${formatNumberWithCommas((credits || 0) * 1000)}</span>
              </div>
              <div className="mt-2 text-xs text-stewie-blue">
                <p>1 credit = $1,000 AUM capacity</p>
                <p>Fee: 10 basis points (0.1%) per trade</p>
              </div>
            </div>
            <p className="text-xs text-stewie-blue">Click to manage your credits</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

// Add default export for compatibility
export default HeaderCreditsDisplay;
